import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import styled from 'styled-components';

import { Link } from '@/types/serviceGroup';
import { Hover } from '@/components/shared/Animation';
import { SsoLinkDescription } from './SsoLinkDescription';

type Props = {
  link: Link;
  serviceGroupId: number;
};

export const SsoLink: React.FC<Props> = ({ link, serviceGroupId }) => (
  <Wrapper>
    <StyledLink href={link.url} rel="noopener noreferrer" target="_blank">
      <Button>
        <InnerWrapper>
          {link.label}
          <FaExternalLinkAlt className="external-link-icon" />
        </InnerWrapper>
      </Button>
    </StyledLink>
    <SsoLinkDescription serviceGroupId={serviceGroupId} label={link.label} />
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;

const Button = styled(Hover)`
  width: 100%;
  min-width: 260px;
  height: 100%;
  min-height: 46px;
  background-color: #d4d4d4;
  color: #292929;
  box-shadow: 0px 2px 10px rgba(110, 110, 110, 0.12);
  > * {
    margin-right: 20px;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  padding-right: 22px;
  font-size: 14px;
  font-weight: bold;
  .external-link-icon {
    color: #5281ff;
  }
`;

const StyledLink = styled.a`
  margin-bottom: 16px;
`;
